import { getBaseUrl } from "./SecurityUtil"

export async function retrieveEidList(accessToken, taxId) {
    const base_url = getBaseUrl();
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    }
    let jsonResp = "";
    try {
        const response = await fetch(`${base_url}/mdmapi/${taxId}`, requestOptions)
        jsonResp = await response.json();
    } catch (error) {
        console.log(`error retrievingByEid: ${error}`);

    }
    return jsonResp;

}
export async function retrieveByEmail(accessToken, emailAddress) {
    const baseUrl = "https://api.finpro.principal.com"; // will always use prod for searching by email 
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': `application/json`,
        'Access-Control-Allow-Origin': `${baseUrl}`,
        'Authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify(
        { 'email': emailAddress,
        "restrictionValue": "PFG_EE" }
      )
    }
    let jsonResp = "";
    try {
      const response = await fetch(`${baseUrl}/mdmapi/retrievePersonByEmail`, requestOptions)
      jsonResp = await response.json();
    } catch (error) {
      console.log(`error retrievingByEmail` + JSON.stringify(error))
    }
    return jsonResp;
  }

  export async function retrieveByEid(accessToken, eid) {
    const base_url = getBaseUrl();
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    }
    let jsonResp = "";
    try {
        const response = await fetch(`${base_url}/mdmapi/retrieveByEid/${eid}`, requestOptions)
        jsonResp = await response.json();
    } catch (error) {
        console.log(`error retrievingByEid: ${error}`);

    }
    return jsonResp;
  }
  export async function retrieveOrgByEid(accessToken, eid) {
    const base_url = getBaseUrl();
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    }
    let jsonResp = "";
    try {
        const response = await fetch(`${base_url}/mdmapi/retrieveOrgByEid/${eid}`, requestOptions)
        jsonResp = await response.json();
    } catch (error) {
        console.log(`error retrievingByEid: ${error}`);

    }
    return jsonResp;
  }